import React from 'react';
import ReactSelect from 'react-select';
import { countryCodes } from '../data/countryCode';

const CountryCodeDropdown = ({ selectedCode, setSelectedCode }) => {
    const countryCodesOptions = countryCodes.map((countryCode) => ({
        value: countryCode.code,
        label: `${countryCode.code} - ${countryCode.name.slice(0, 3).toUpperCase()}`,
    }));


    const handleCountryCodeChange = (selectedOption) => {
        console.log('Selected country code:', selectedOption);
        setSelectedCode(selectedOption.value)
    };

    return (
        <ReactSelect
            options={countryCodesOptions}
            placeholder="Country Code"
            value={countryCodesOptions.filter((item) => item.value === selectedCode)}
            onChange={handleCountryCodeChange}
            className='fs_12 text-nowrap'
            styles={customStyles}
        />
    );
};

const customStyles = {
    control: (provided) => ({
        ...provided,
        width: '90px', // Custom width
    }),
    dropdownIndicator: () => ({
        display: 'none', // Hide dropdown indicator arrow
    }),
    indicatorSeparator: () => ({
        display: 'none', // Hide the separator
    }),
    menu: (provided) => ({
        ...provided,
        maxHeight: '150px', 
        overflowY: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    }),
    menuList: (provided) => ({
        ...provided,
        '::-webkit-scrollbar': {
            display: 'none',
        },
    }),
};

export default CountryCodeDropdown;